var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"audios",staticClass:"audios"},_vm._l((_vm.audios),function(audio,index){return _c('Audio',{key:index,attrs:{"audio":audio},on:{"playing":_vm.onPlaying}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }